import { API_FLAG, REQUEST_PARAMS } from './constants';

/**
 * 協力会社一覧
 * //https://v2-dev.buildee.jp/apidocs/public/field_trees/operatable_ids.html
 */
export const field_tree_id = props => {
  return {
    url: `/api/private/fields/${props.fieldId}/field_trees/operatable_ids`,
    params: {},
    dataPath: 'data.entities.field_trees', //一覧情報の入っているパス
    label: 'company_name', //一覧表示名
    keyid: 'id', //取得するidのキー
    searchKey: 'name', //ドロップダウンの入力input名
  };
};

/**
 * 協力会社一覧全部
 * //https://v2-dev.buildee.jp/apidocs/public/field_trees/tree_company_branches.html
 * /api/private/fields/:field_id/field_trees/tree_company_branches
 */
export const field_tree_id_all = props => {
  return {
    url: `/api/private/fields/${
      props.fieldId
    }/field_trees/tree_company_branches`,
    params: { deduplicationflag: 1 },
    dataPath: 'data.entities.field_trees', //一覧情報の入っているパス
    label: 'company_name', //一覧表示名
    keyid: 'company_id', //取得するidのキー
    searchKey: 'name', //ドロップダウンの入力input名
  };
};

/**
 * 協力会社一覧CSV
 * //https://v2-dev.buildee.jp/apidocs/public/field_trees/tree_company_branches.html
 * /api/private/fields/:field_id/field_trees/tree_company_branches
 */
export const field_tree_id_all_csv = props => {
  return {
    url: `/api/private/fields/${
      props.fieldId
    }/field_trees/tree_company_branches`,
    params: { deduplicationflag: 1, limit: REQUEST_PARAMS.parentLimit },
    dataPath: 'data.entities.field_trees', //一覧情報の入っているパス
    label: 'company_name', //一覧表示名
    keyid: 'company_branch_id', //取得するidのキー
    searchKey: 'name', //ドロップダウンの入力input名
  };
};

/**
 * 協力会社一覧絞り込み全部
 * //https://v2-dev.buildee.jp/apidocs/public/field_trees/tree_company_branches.html
 * /api/private/fields/:field_id/field_trees/tree_company_branches
 */
export const company_branch_id_all = props => {
  return {
    url: `/api/private/fields/${
      props.fieldId
    }/field_trees/tree_company_branches`,
    params: {
      offset: props.offset,
      limit: REQUEST_PARAMS.parentLimit,
      deduplicationflag: API_FLAG.On,
      jv_company_branch_id: props.jvCompanyBranchId,
    },
    dataPath: 'data.entities.field_trees', //一覧情報の入っているパス
    label: 'company_name', //一覧表示名
    keyid: 'company_branch_id', //取得するidのキー
    searchKey: 'name', //ドロップダウンの入力input名
  };
};

//JV
//https://v2-dev.buildee.jp/apidocs/public/company_branches/jv_company_list.html
///api/private/fields/:field_id/jv_company_list
export const jv_company_list = props => {
  return {
    url: `/api/private/fields/${props.fieldId}/jv_company_list`,
    params: {},
    dataPath: 'data.entities.company', //一覧情報の入っているパス
    label: 'name', //一覧表示名
    keyid: 'id', //取得するidのキー
    searchKey: 'name', //ドロップダウンの入力input名
  };
};

/**
 * 体系図職長一覧 全体
 * https://v2-dev.buildee.jp/apidocs/public/field_trees/user_list.html
 * /api/private/fields/:field_id/field_trees/user_list
 */
export const foreman_user_id = props => {
  return {
    url: `/api/private/fields/${props.fieldId}/field_trees/user_list`,
    params: {
      jv_company_branch_id: props.jvCompanyBranchId,
    },
    dataPath: 'data.entities.user_lists', //一覧情報の入っているパス
    label: 'display_user_fullname', //一覧表示名
    keyid: 'id', //取得するidのキー
    searchKey: 'name', //ドロップダウンの入力input名
  };
};

/**
 * 体系図職長一覧
 * https://v2-dev.buildee.jp/apidocs/public/field_trees/tree_users.html
 * /api/private/fields/:field_id/field_trees/tree_users
 */
// export const foreman_user_id = (props)=>{
//   return {
//     url : `/api/private/fields/${props.fieldId}/field_trees/tree_users`,
//     params : {},
//     dataPath : "data.entities.field_tree_user",//一覧情報の入っているパス
//     label : "user_name",//一覧表示名
//     keyid : "user_id",//取得するidのキー
//     searchKey:"name",//ドロップダウンの入力input名
//   }
// }

//体系図 職種一覧
//https://v2-dev.buildee.jp/apidocs/public/jobs/list.html
///api/private/jobs/list
///api/private/fields/1/field_trees/tree_jobs
//https://v2-dev.buildee.jp/apidocs/public/field_trees/tree_jobs.html

// eslint-disable-next-line no-unused-vars
export const job_id = props => {
  return {
    //url : `/api/private/fields/${props.fieldId}/field_trees/job_list`,
    url: `/api/private/jobs/list`,
    params: { display_flag: 1 },
    dataPath: 'data.entities.jobs',
    label: 'name',
    keyid: 'id',
    searchKey: 'name',
  };
};

//体系図 現場職種一覧
///api/private/fields/1/field_trees/tree_jobs
//https://v2-dev.buildee.jp/apidocs/public/field_trees/tree_jobs.html
export const field_job_id = props => {
  return {
    url: `/api/private/fields/${props.fieldId}/field_trees/job_list`,
    //url : `/api/private/jobs/list`,
    params: {},
    dataPath: 'data.entities.jobs',
    label: 'name',
    keyid: 'id',
    searchKey: 'name',
  };
};

//体系図 作業員追加画面 職種一覧
//https://v2-dev.buildee.jp/apidocs/public/jobs/list.html
///api/private/jobs/list
///api/private/fields/1/field_trees/tree_jobs
//https://v2-dev.buildee.jp/apidocs/public/field_trees/tree_jobs.html
export const worker_job_id = props => {
  return {
    //url : `/api/private/fields/${props.fieldId}/jobs/list`,
    url: `/api/private/jobs/list`,
    params: { display_flag: 1, field_id: props.fieldId },
    dataPath: 'data.entities.jobs',
    label: 'name',
    keyid: 'id',
    searchKey: 'name',
  };
};

//マスターの職種一覧
//https://v2-dev.buildee.jp/apidocs/public/jobs/list.html
export const master_job = props => {
  return {
    url: `/api/private/company_branches/${props.companyBranchId}/jobs/list`,
    params: {},
    dataPath: 'data.jobs', //一覧情報の入っているパス
    label: 'name',
    keyid: 'id',
    searchKey: 'name',
  };
};

//技能講習
export const training_name_dropdown = props => {
  return {
    url: `/api/private/ccus/masters/skill_course_licentiates`,
    params: { display_flag: 1, field_id: props.fieldId },
    dataPath: 'data.entities.skill_course_licentiates',
    label: 'training_name',
    keyid: 'training_code',
    searchKey: 'name',
  };
};

//特別教育
export const specal_training_name_dropdown = props => {
  return {
    url: `/api/private/ccus/masters/special_education_licentiates`,
    params: { display_flag: 1, field_id: props.fieldId },
    dataPath: 'data.entities.special_education_licentiates',
    label: 'specal_training_name',
    keyid: 'specal_training_code',
    searchKey: 'name',
  };
};

//安全衛生講習
export const safety_training_name_dropdown = props => {
  return {
    url: `/api/private/ccus/masters/other_licentiates`,
    params: { display_flag: 1, field_id: props.fieldId },
    dataPath: 'data.entities.other_licentiates',
    label: 'safety_training_name',
    keyid: 'safety_training_code',
    searchKey: 'name',
  };
};

//表彰
export const commendation_name_dropdown = props => {
  return {
    url: `/api/private/ccus/masters/commendations`,
    params: { display_flag: 1, field_id: props.fieldId },
    dataPath: 'data.entities.commendations',
    label: 'commendation_name',
    keyid: 'commendation_code',
    searchKey: 'name',
  };
};

//基幹技能者
export const core_technician_name_dropdown = props => {
  return {
    url: `/api/private/ccus/masters/touroku_kikan_ginousyas`,
    params: { display_flag: 1, field_id: props.fieldId },
    dataPath: 'data.entities.touroku_kikan_ginousyas',
    label: 'core_technician_name',
    keyid: 'core_technician_code',
    searchKey: 'name',
  };
};

//技能者
export const engineer_licenses_name_dropdown = props => {
  return {
    url: `/api/private/ccus/masters/technician_licentiates`,
    params: { display_flag: 1, field_id: props.fieldId },
    dataPath: 'data.entities.technician_licentiates',
    label: 'engineer_licenses_name',
    keyid: 'engineer_licenses_code',
    searchKey: 'name',
  };
};

//資格
export const licenses_name_dropdown = props => {
  return {
    url: `/api/private/ccus/masters/qualification_license_licentiates`,
    params: { display_flag: 1, field_id: props.fieldId },
    dataPath: 'data.entities.qualification_license_licentiates',
    label: 'licenses_name',
    keyid: 'licenses_code',
    searchKey: 'name',
  };
};

//技能職種
export const job_name_dropdown = props => {
  return {
    url: `/api/private/ccus/masters/ginou_syokusyus`,
    params: { display_flag: 1, field_id: props.fieldId },
    dataPath: 'data.entities.ginou_syokusyus',
    label: 'job_name',
    keyid: 'ccus_job_code_s',
    searchKey: 'name',
  };
};

//続柄用
export const relation_ship_dropdown = props => {
  return {
    url: `/api/private/ccus/masters/family_relationships`,
    params: { display_flag: 1, field_id: props.fieldId },
    dataPath: 'data.entities.family_relationships',
    label: 'relationship',
    keyid: 'relationship_code',
    searchKey: 'name',
  };
};

//健康保健除外用
export const health_insurance_reason_exclusion_dropdown = props => {
  return {
    url: `/api/private/ccus/masters/health_ins_reasons`,
    params: { display_flag: 1, field_id: props.fieldId },
    dataPath: 'data.entities.health_ins_reasons',
    label: 'health_insurance_reason_exclusion',
    keyid: 'ccus_health_insurance_reason_exclusion_code',
    searchKey: 'name',
  };
};

//年金除外用
export const pension_reason_exclusion_dropdown = props => {
  return {
    url: `/api/private/ccus/masters/pension_ins_reasons`,
    params: { display_flag: 1, field_id: props.fieldId },
    dataPath: 'data.entities.pension_ins_reasons',
    label: 'pension_reason_exclusion',
    keyid: 'ccus_pension_reason_exclusion_code',
    searchKey: 'name',
  };
};

//健康種類
export const health_insurance_typen_dropdown = props => {
  return {
    url: `/api/private/ccus/masters/health_ins_types`,
    params: { display_flag: 1, field_id: props.fieldId },
    dataPath: 'data.entities.health_ins_types',
    label: 'health_insurance_type',
    keyid: 'health_insurance_type_code',
    searchKey: 'name',
  };
};

//年金種類
export const pension_type_dropdown = props => {
  return {
    url: `/api/private/ccus/masters/pension_ins_types`,
    params: { display_flag: 1, field_id: props.fieldId },
    dataPath: 'data.entities.pension_ins_types',
    label: 'pension_type',
    keyid: 'pension_type_code',
    searchKey: 'name',
  };
};

//雇用種類
export const employment_insurance_type_dropdown = props => {
  return {
    url: `/api/private/ccus/masters/employment_ins_types`,
    params: { display_flag: 1, field_id: props.fieldId },
    dataPath: 'data.entities.employment_ins_types',
    label: 'employment_insurance_type',
    keyid: 'employment_insurance_type_code',
    searchKey: 'name',
  };
};

//雇用除外用
export const employment_insurance_reason_exclusion_dropdown = props => {
  return {
    url: `/api/private/ccus/masters/employment_ins_reasons`,
    params: { display_flag: 1, field_id: props.fieldId },
    dataPath: 'data.entities.employment_ins_reasons',
    label: 'employment_insurance_reason_exclusion',
    keyid: 'ccus_employment_insurance_reason_exclusion_code',
    searchKey: 'name',
  };
};

/**
 * 現場監督一覧
 * @param {*} props
 * https://v2-dev.buildee.jp/apidocs/public/fields/manager_lists.html
 * /api/private/fields/:field_id/manager_lists
 */
export const master_manager_list = props => {
  return {
    url: `/api/private/company_branches/${props.fieldId}/manager_lists`,
    params: {},
    dataPath: 'data.entities.user_lists', //一覧情報の入っているパス
    label: 'fullname',
    keyid: 'id',
    searchKey: 'name',
  };
};

/**
 * 現場紐付監督一覧
 * @param {*} props
 * https://v2-dev.buildee.jp/apidocs/public/field_contractor_users/list.html
 * /api/private/fields/:field_id/field_contractor_users/list
 */
export const master_constructor_manager_list = props => {
  return {
    url: `/api/private/fields/${props.fieldId}/field_contractor_users/list`,
    params: { jv_company_branch_id: props.jvCompanyBranchId },
    dataPath: 'data.entities.field_contractor_users', //一覧情報の入っているパス
    label: 'user_name',
    keyid: 'id',
    searchKey: 'name',
  };
};

/**
 * ユーザーからみた元請の支店一覧
 * 〇 https://v2-dev.buildee.jp/apidocs/public/company_branches/prime_list.html
 * × https://v2-dev.buildee.jp/apidocs/public/company_branches/list.html
 *
 * 〇 /api/private/company_branches/prime_list
 * × /api/private/company_branches/list
 */
export const master_branches_list = () => {
  return {
    url: '/api/private/company_branches/prime_list',
    params: {},
    dataPath: 'data.entities.company.company_branches', //一覧情報の入っているパス
    label: 'name',
    keyid: 'id',
    searchKey: 'name',
  };
};

/**
 * 支店一覧
 */
export const branches_list = props => {
  return {
    url: '/api/private/company_branches/list',
    params: {
      my_branch: props.my_branch,
      jv_company_branch_id: props.jv_company_branch_id,
    },
    dataPath: 'data.entities.company_branches', //一覧情報の入っているパス
    label: 'name',
    keyid: 'id',
    searchKey: 'name',
  };
};

/**
 * 協力会社一覧
 * https://v2-dev.buildee.jp/apidocs/public/company_branches/company_partner_list.html
 * /api/private/company_branches/company_partner_list
 */
export const partner_company = () => {
  return {
    url: '/api/private/company_branches/company_partner_list',
    params: { limit: 30 },
    dataPath: 'data.entities.company', //一覧情報の入っているパス
    label: 'name',
    keyid: 'id',
    searchKey: 'name',
  };
};

/**
 * 協力会社名 電話検索
 * https://v2-dev.buildee.jp/apidocs/public/company_branches/company_partner_list.html
 * /api/private/company_branches/company_partner_list
 */
export const partner_company_id_by_tel = () => {
  return {
    url: '/api/private/company_branches/company_partner_list',
    params: { limit: 30 },
    dataPath: 'data.entities.company', //一覧情報の入っているパス
    label: 'name',
    keyid: 'id',
    searchKey: 'tel',
  };
};

/**
 * 協力会社名 住所検索
 * https://v2-dev.buildee.jp/apidocs/public/company_branches/company_partner_list.html
 * /api/private/company_branches/company_partner_list
 */
export const partner_company_id_by_address = () => {
  return {
    url: '/api/private/company_branches/company_partner_list',
    params: { limit: 30 },
    dataPath: 'data.entities.company', //一覧情報の入っているパス
    label: 'name',
    keyid: 'id',
    searchKey: 'address',
  };
};

/**
 * 現場に紐づく元請会社、協力会社情報
 */
export const all_company_in_field = props => {
  return {
    url: `/${props.fieldId}/field_trees/field_all_companies`,
    params: {},
    dataPath: 'data.entities.companies', //一覧情報の入っているパス
    label: 'name',
    keyid: 'id',
    searchKey: 'name',
  };
};

/**
 * 現場監督・支店管理者一覧
 * https://v2-dev.buildee.jp/apidocs/public/field_users/list.html
 * /api/private/field_users/list
 */
export const field_users_list = () => {
  return {
    url: '/api/private/field_users/list',
    params: {},
    dataPath: 'data.entities.users', //一覧情報の入っているパス
    label: 'name_sei',
    keyid: 'id',
    searchKey: 'name',
  };
};

/**
 * 元請け職種マスター
 * @param {*} props
 * https://v2-dev.buildee.jp/apidocs/public/positions/list.html
 * /api/private/company_branches/:id/positions/list
 */
export const master_constructor_position = props => {
  return {
    url: `/api/private/positions/list`,
    //url: `/api/private/positions/list`,
    params: {
      company_branch_id: props.companyBranchId,
      display_flag: 1,
    },
    dataPath: 'data.entities.positions', //一覧情報の入っているパス
    label: 'name',
    keyid: 'id',
    searchKey: 'name',
  };
};

/**
 * 承認権限マスター
 * @param {*} props
 * https://v2-dev.buildee.jp/apidocs/public/field_approvals/index.html
 * /api/private/fields/:field_id/field_approvals
 */
export const master_approval = props => {
  return {
    url: `/api/private/company_branches/${props.fieldId}/field_approvals`,
    params: {},
    dataPath: 'data.entities.field_approvals', //一覧情報の入っているパス
    label: 'approval_level',
    keyid: 'id',
    searchKey: 'name',
  };
};

//グループ一覧
///api/private/fields/:field_id/field_groups/list?limit=:limit¥&offset=:offset¥&columns=:columns¥&order=:order
export const field_groups = props => {
  return {
    url: `/api/private/fields/${props.fieldId}/field_groups/list`,
    params: {},
    dataPath: 'data.entities.field_groups', //一覧情報の入っているパス
    label: 'name',
    keyid: 'id',
    searchKey: 'name',
  };
};

/**
 * 協力会社ユーザー一覧
 * https://v2-dev.buildee.jp/apidocs/public/company_branches/company_partner_user_list.html
 * /api/private/fields/:field_id/field_trees/:field_tree_id/field_tree_users/list
 */
export const company_partner_user_list = props => {
  return {
    url: `/api/private/fields/${props.fieldId}/field_trees/${
      props.fieldTreeId
    }/field_tree_users/list`,
    params: {},
    dataPath: 'data.entities.field_tree_users', //一覧情報の入っているパス
    label: 'fullname',
    keyid: 'user_id',
    searchKey: 'name',
  };
};

/**
 * 協力会社ユーザー一覧CSV
 * https://v2-dev.buildee.jp/apidocs/public/company_branches/company_partner_user_list.html
 * /api/private/fields/:field_id/field_trees/:field_tree_id/field_tree_users/list
 */
export const company_partner_user_list_csv = props => {
  return {
    url: `/api/private/fields/${props.fieldId}/field_trees/${
      props.fieldTreeId
    }/field_tree_users/list`,
    params: {},
    dataPath: 'data.entities.field_tree_users', //一覧情報の入っているパス
    label: 'fullname',
    keyid: 'id',
    searchKey: 'name',
  };
};

//指定した現場に登録可能な元請ユーザーを取得します
///api/private/fields/:field_id/field_contractor_users/registable_list
//https://v2-dev.buildee.jp/apidocs/public/field_contractor_users/registable_list.html
export const field_constructor_users = props => {
  console.log('field_constructor_users = ', props.params);
  return {
    url: `/api/private/fields/${
      props.fieldId
    }/field_contractor_users/registable_list`,
    params: props.params || {}, //パラメータを入れる
    dataPath: 'data.entities.user_lists', //一覧情報の入っているパス
    label: 'fullname',
    keyid: 'id',
    searchKey: 'name',
  };
};

//現場紐付監督一覧の情報を取得します
///api/private/fields/:field_id/field_contractor_users/list
//https://v2-dev.buildee.jp/apidocs/public/field_contractor_users/list.html
export const field_constructor_users_current = props => {
  console.log('field_constructor_users = ', props.params);
  return {
    url: `/api/private/fields/${props.fieldId}/field_contractor_users/list`,
    params: props.params || {}, //パラメータを入れる
    dataPath: 'data.entities.field_contractor_users', //一覧情報の入っているパス
    label: 'user_name',
    keyid: 'user_id',
    searchKey: 'name',
  };
};

// eslint-disable-next-line no-unused-vars
export const manager_user_id = field_id => {
  return {
    url: `/api/private/field_manager_users/list`,
    params: {},
    label: 'name',
    keyid: 'id',
    entitiesKey: 'field_manager_users',
    searchKey: 'name',
  };
};
export const a_item_id = field_id => {
  return {
    url: `/api/private/fields/${field_id}/field_item_lists/list`,
    params: { item_list_id: 1 },
    label: 'name',
    keyid: 'id',
    entitiesKey: 'field_item_lists',
    searchKey: 'name',
  };
};
export const b_item_id = field_id => {
  return {
    url: `/api/private/fields/${field_id}/field_item_lists/list`,
    params: { item_list_id: 2 },
    label: 'name',
    keyid: 'id',
    entitiesKey: 'field_item_lists',
    searchKey: 'name',
  };
};

export const c_item_id = field_id => {
  return {
    url: `/api/private/fields/${field_id}/field_item_lists/list`,
    params: { item_list_id: 3 },
    label: 'name',
    keyid: 'id',
    entitiesKey: 'field_item_lists',
    searchKey: 'name',
  };
};

//工区
export const d_item_id = field_id => {
  return {
    url: `/api/private/fields/${field_id}/field_item_lists/list`,
    params: { item_list_id: 4 },
    label: 'name',
    keyid: 'id',
    entitiesKey: 'field_item_lists',
    searchKey: 'name',
  };
};

//支店名
export const company_id = () => {
  return {
    url: '/api/private/company_branches/list',
    params: {},
    label: 'name',
    keyid: 'company_id',
    entitiesKey: 'company_branches',
    searchKey: 'name',
  };
};

// 現場
export const fields = () => {
  return {
    url: '/api/private/fields',
    params: {},
    label: 'name',
    keyid: 'field_id',
    entitiesKey: 'fields',
    searchKey: 'name',
  };
};

// キープラン
export const key_plan_category_code = field_id => {
  return {
    url: `/api/private/fields/${field_id}/field_images/keyplan`,
    params: {},
    label: 'image',
    entitiesKey: 'field_images',
  };
};

export const companies = () => {
  return {
    url: '/api/private/companies/list',
    params: {},
    label: 'name',
    entitiesKey: 'companies',
  };
};

export const user_list = () => {
  return {
    url: '/api/private/users/list',
    params: {
      user_role_code: 5,
    },
  };
};



// WEBPACK FOOTER //
// ./src/utilities/apiUrl.js